  export const countryRegionMapping = [
      { country: "Afghanistan", region: "Southern Asia", continent: "Asia" },
  { country: "Aland", region: "Northern Europe", continent: "Europe" },
  { country: "Albania", region: "Southern Europe", continent: "Europe" },
  { country: "Algeria", region: "Northern Africa", continent: "Africa" },
  { country: "American Samoa", region: "Polynesia", continent: "Oceania" },
  { country: "Andorra", region: "Southern Europe", continent: "Europe" },
  { country: "Angola", region: "Middle Africa", continent: "Africa" },
  { country: "Anguilla", region: "Caribbean", continent: "Americas" },
  { country: "Antigua and Barbuda", region: "Caribbean", continent: "Americas" },
  { country: "Argentina", region: "South America", continent: "Americas" },
  { country: "Armenia", region: "Western Asia", continent: "Asia" },
  { country: "Aruba", region: "Caribbean", continent: "Americas" },
  { country: "Ashmore and Cartier Islands", region: "Australia and New Zealand", continent: "Oceania" },
  { country: "Australia", region: "Australia and New Zealand", continent: "Oceania" },
  { country: "Austria", region: "Western Europe", continent: "Europe" },
  { country: "Azerbaijan", region: "Western Asia", continent: "Asia" },
  { country: "Bahrain", region: "Western Asia", continent: "Asia" },
  { country: "Bangladesh", region: "Southern Asia", continent: "Asia" },
  { country: "Barbados", region: "Caribbean", continent: "Americas" },
  { country: "Belarus", region: "Eastern Europe", continent: "Europe" },
  { country: "Belgium", region: "Western Europe", continent: "Europe" },
  { country: "Belize", region: "Central America", continent: "Americas" },
  { country: "Benin", region: "Western Africa", continent: "Africa" },
  { country: "Bermuda", region: "Northern America", continent: "Americas" },
  { country: "Bhutan", region: "Southern Asia", continent: "Asia" },
  { country: "Bolivia", region: "South America", continent: "Americas" },
  { country: "Bosnia and Herzegovina", region: "Southern Europe", continent: "Europe" },
  { country: "Botswana", region: "Southern Africa", continent: "Africa" },
  { country: "Brazil", region: "South America", continent: "Americas" },
  { country: "British Indian Ocean Territory", region: "Eastern Africa", continent: "Africa" },
  { country: "British Virgin Islands", region: "Caribbean", continent: "Americas" },
  { country: "Brunei", region: "South-eastern Asia", continent: "Asia" },
  { country: "Bulgaria", region: "Eastern Europe", continent: "Europe" },
  { country: "Burkina Faso", region: "Western Africa", continent: "Africa" },
  { country: "Burundi", region: "Eastern Africa", continent: "Africa" },
  { country: "Cabo Verde", region: "Western Africa", continent: "Africa" },
  { country: "Cambodia", region: "South-eastern Asia", continent: "Asia" },
  { country: "Cameroon", region: "Middle Africa", continent: "Africa" },
  { country: "Canada", region: "Northern America", continent: "Americas" },
  { country: "Cayman Islands", region: "Caribbean", continent: "Americas" },
  { country: "Central African Republic", region: "Middle Africa", continent: "Africa" },
  { country: "Chad", region: "Middle Africa", continent: "Africa" },
  { country: "Chile", region: "South America", continent: "Americas" },
  { country: "China", region: "Eastern Asia", continent: "Asia" },
  { country: "Colombia", region: "South America", continent: "Americas" },
  { country: "Comoros", region: "Eastern Africa", continent: "Africa" },
  { country: "Cook Islands", region: "Polynesia", continent: "Oceania" },
  { country: "Costa Rica", region: "Central America", continent: "Americas" },
  { country: "Croatia", region: "Southern Europe", continent: "Europe" },
  { country: "Cuba", region: "Caribbean", continent: "Americas" },
  { country: "Cura�ao", region: "Caribbean", continent: "Americas" },
  { country: "Cyprus", region: "Western Asia", continent: "Asia" },
  { country: "Czechia", region: "Eastern Europe", continent: "Europe" },
  { country: "Democratic Republic of the Congo", region: "Middle Africa", continent: "Africa" },
  { country: "Denmark", region: "Northern Europe", continent: "Europe" },
  { country: "Djibouti", region: "Eastern Africa", continent: "Africa" },
  { country: "Dominica", region: "Caribbean", continent: "Americas" },
  { country: "Dominican Republic", region: "Caribbean", continent: "Americas" },
  { country: "East Timor", region: "South-eastern Asia", continent: "Asia" },
  { country: "Ecuador", region: "South America", continent: "Americas" },
  { country: "Egypt", region: "Northern Africa", continent: "Africa" },
  { country: "El Salvador", region: "Central America", continent: "Americas" },
  { country: "Equatorial Guinea", region: "Middle Africa", continent: "Africa" },
  { country: "Eritrea", region: "Eastern Africa", continent: "Africa" },
  { country: "Estonia", region: "Northern Europe", continent: "Europe" },
  { country: "eSwatini", region: "Southern Africa", continent: "Africa" },
  { country: "Ethiopia", region: "Eastern Africa", continent: "Africa" },
  { country: "Falkland Islands", region: "South America", continent: "Americas" },
  { country: "Faroe Islands", region: "Northern Europe", continent: "Europe" },
  { country: "Federated States of Micronesia", region: "Micronesia", continent: "Oceania" },
  { country: "Fiji", region: "Melanesia", continent: "Oceania" },
  { country: "Finland", region: "Northern Europe", continent: "Europe" },
  { country: "France", region: "Western Europe", continent: "Europe" },
  { country: "French Polynesia", region: "Polynesia", continent: "Oceania" },
  { country: "French Southern and Antarctic Lands", region: "Eastern Africa", continent: "Africa" },
  { country: "Gabon", region: "Middle Africa", continent: "Africa" },
  { country: "Gambia", region: "Western Africa", continent: "Africa" },
  { country: "Georgia", region: "Western Asia", continent: "Asia" },
  { country: "Germany", region: "Western Europe", continent: "Europe" },
  { country: "Ghana", region: "Western Africa", continent: "Africa" },
  { country: "Greece", region: "Southern Europe", continent: "Europe" },
  { country: "Greenland", region: "Northern America", continent: "Americas" },
  { country: "Grenada", region: "Caribbean", continent: "Americas" },
  { country: "Guam", region: "Micronesia", continent: "Oceania" },
  { country: "Guatemala", region: "Central America", continent: "Americas" },
  { country: "Guernsey", region: "Northern Europe", continent: "Europe" },
  { country: "Guinea", region: "Western Africa", continent: "Africa" },
  { country: "Guinea-Bissau", region: "Western Africa", continent: "Africa" },
  { country: "Guyana", region: "South America", continent: "Americas" },
  { country: "Haiti", region: "Caribbean", continent: "Americas" },
  { country: "Heard Island and McDonald Islands", region: "Australia and New Zealand", continent: "Oceania" },
  { country: "Honduras", region: "Central America", continent: "Americas" },
  { country: "Hong Kong S.A.R.", region: "Eastern Asia", continent: "Asia" },
  { country: "Hungary", region: "Eastern Europe", continent: "Europe" },
  { country: "Iceland", region: "Northern Europe", continent: "Europe" },
  { country: "India", region: "Southern Asia", continent: "Asia" },
  { country: "Indian Ocean Territories", region: "NULL", continent: "Asia" },
  { country: "Indonesia", region: "South-eastern Asia", continent: "Asia" },
  { country: "Iran", region: "Southern Asia", continent: "Asia" },
  { country: "Iraq", region: "Western Asia", continent: "Asia" },
  { country: "Ireland", region: "Northern Europe", continent: "Europe" },
  { country: "Isle of Man", region: "Northern Europe", continent: "Europe" },
  { country: "Israel", region: "Western Asia", continent: "Asia" },
  { country: "Italy", region: "Southern Europe", continent: "Europe" },
  { country: "Ivory Coast", region: "Western Africa", continent: "Africa" },
  { country: "Jamaica", region: "Caribbean", continent: "Americas" },
  { country: "Japan", region: "Eastern Asia", continent: "Asia" },
  { country: "Jersey", region: "Northern Europe", continent: "Europe" },
  { country: "Jordan", region: "Western Asia", continent: "Asia" },
  { country: "Kazakhstan", region: "Central Asia", continent: "Asia" },
  { country: "Kenya", region: "Eastern Africa", continent: "Africa" },
  { country: "Kiribati", region: "Micronesia", continent: "Oceania" },
  { country: "Kosovo", region: "Eastern Europe", continent: "Europe" },
  { country: "Kuwait", region: "Western Asia", continent: "Asia" },
  { country: "Kyrgyzstan", region: "Central Asia", continent: "Asia" },
  { country: "Laos", region: "South-eastern Asia", continent: "Asia" },
  { country: "Latvia", region: "Northern Europe", continent: "Europe" },
  { country: "Lebanon", region: "Western Asia", continent: "Asia" },
  { country: "Lesotho", region: "Southern Africa", continent: "Africa" },
  { country: "Liberia", region: "Western Africa", continent: "Africa" },
  { country: "Libya", region: "Northern Africa", continent: "Africa" },
  { country: "Liechtenstein", region: "Western Europe", continent: "Europe" },
  { country: "Lithuania", region: "Northern Europe", continent: "Europe" },
  { country: "Luxembourg", region: "Western Europe", continent: "Europe" },
  { country: "Macao S.A.R", region: "Eastern Asia", continent: "Asia" },
  { country: "Macedonia", region: "Southern Europe", continent: "Europe" },
  { country: "Madagascar", region: "Eastern Africa", continent: "Africa" },
  { country: "Malawi", region: "Eastern Africa", continent: "Africa" },
  { country: "Malaysia", region: "South-eastern Asia", continent: "Asia" },
  { country: "Maldives", region: "Southern Asia", continent: "Asia" },
  { country: "Mali", region: "Western Africa", continent: "Africa" },
  { country: "Malta", region: "Southern Europe", continent: "Europe" },
  { country: "Marshall Islands", region: "Micronesia", continent: "Oceania" },
  { country: "Mauritania", region: "Western Africa", continent: "Africa" },
  { country: "Mauritius", region: "Eastern Africa", continent: "Africa" },
  { country: "Mexico", region: "Central America", continent: "Americas" },
  { country: "Moldova", region: "Eastern Europe", continent: "Europe" },
  { country: "Monaco", region: "Western Europe", continent: "Europe" },
  { country: "Mongolia", region: "Eastern Asia", continent: "Asia" },
  { country: "Montenegro", region: "Southern Europe", continent: "Europe" },
  { country: "Montserrat", region: "Caribbean", continent: "Americas" },
  { country: "Morocco", region: "Northern Africa", continent: "Africa" },
  { country: "Mozambique", region: "Eastern Africa", continent: "Africa" },
  { country: "Myanmar", region: "South-eastern Asia", continent: "Asia" },
  { country: "Namibia", region: "Southern Africa", continent: "Africa" },
  { country: "Nauru", region: "Micronesia", continent: "Oceania" },
  { country: "Nepal", region: "Southern Asia", continent: "Asia" },
  { country: "Netherlands", region: "Western Europe", continent: "Europe" },
  { country: "New Caledonia", region: "Melanesia", continent: "Oceania" },
  { country: "New Zealand", region: "Australia and New Zealand", continent: "Oceania" },
  { country: "Nicaragua", region: "Central America", continent: "Americas" },
  { country: "Niger", region: "Western Africa", continent: "Africa" },
  { country: "Nigeria", region: "Western Africa", continent: "Africa" },
  { country: "Niue", region: "Polynesia", continent: "Oceania" },
  { country: "Norfolk Island", region: "Australia and New Zealand", continent: "Oceania" },
  { country: "North Korea", region: "Eastern Asia", continent: "Asia" },
  { country: "Northern Cyprus", region: "Western Asia", continent: "Asia" },
  { country: "Northern Mariana Islands", region: "Micronesia", continent: "Oceania" },
  { country: "Norway", region: "Northern Europe", continent: "Europe" },
  { country: "Oman", region: "Western Asia", continent: "Asia" },
  { country: "Pakistan", region: "Southern Asia", continent: "Asia" },
  { country: "Palau", region: "Micronesia", continent: "Oceania" },
  { country: "Palestine", region: "Western Asia", continent: "Asia" },
  { country: "Panama", region: "Central America", continent: "Americas" },
  { country: "Papua New Guinea", region: "Melanesia", continent: "Oceania" },
  { country: "Paraguay", region: "South America", continent: "Americas" },
  { country: "Peru", region: "South America", continent: "Americas" },
  { country: "Philippines", region: "South-eastern Asia", continent: "Asia" },
  { country: "Pitcairn Islands", region: "Polynesia", continent: "Oceania" },
  { country: "Poland", region: "Eastern Europe", continent: "Europe" },
  { country: "Portugal", region: "Southern Europe", continent: "Europe" },
  { country: "Puerto Rico", region: "Caribbean", continent: "Americas" },
  { country: "Qatar", region: "Western Asia", continent: "Asia" },
  { country: "Republic of Serbia", region: "Southern Europe", continent: "Europe" },
  { country: "Republic of the Congo", region: "Middle Africa", continent: "Africa" },
  { country: "Romania", region: "Eastern Europe", continent: "Europe" },
  { country: "Russia", region: "Eastern Europe", continent: "Europe" },
  { country: "Rwanda", region: "Eastern Africa", continent: "Africa" },
  { country: "Saint Barthelemy", region: "Caribbean", continent: "Americas" },
  { country: "Saint Helena", region: "Western Africa", continent: "Africa" },
  { country: "Saint Kitts and Nevis", region: "Caribbean", continent: "Americas" },
  { country: "Saint Lucia", region: "Caribbean", continent: "Americas" },
  { country: "Saint Martin", region: "Caribbean", continent: "Americas" },
  { country: "Saint Pierre and Miquelon", region: "Northern America", continent: "Americas" },
  { country: "Saint Vincent and the Grenadines", region: "Caribbean", continent: "Americas" },
  { country: "Samoa", region: "Polynesia", continent: "Oceania" },
  { country: "San Marino", region: "Southern Europe", continent: "Europe" },
  { country: "Sao Tomé and Principe", region: "Middle Africa", continent: "Africa" },
  { country: "Saudi Arabia", region: "Western Asia", continent: "Asia" },
  { country: "Senegal", region: "Western Africa", continent: "Africa" },
  { country: "Seychelles", region: "Eastern Africa", continent: "Africa" },
  { country: "Siachen Glacier", region: "Southern Asia", continent: "Asia" },
  { country: "Sierra Leone", region: "Western Africa", continent: "Africa" },
  { country: "Singapore", region: "South-eastern Asia", continent: "Asia" },
  { country: "Sint Maarten", region: "Caribbean", continent: "Americas" },
  { country: "Slovakia", region: "Eastern Europe", continent: "Europe" },
  { country: "Slovenia", region: "Southern Europe", continent: "Europe" },
  { country: "Solomon Islands", region: "Melanesia", continent: "Oceania" },
  { country: "Somalia", region: "Eastern Africa", continent: "Africa" },
  { country: "Somaliland", region: "Eastern Africa", continent: "Africa" },
  { country: "South Africa", region: "Southern Africa", continent: "Africa" },
  { country: "South Korea", region: "Eastern Asia", continent: "Asia" },
  { country: "South Sudan", region: "Eastern Africa", continent: "Africa" },
  { country: "Spain", region: "Southern Europe", continent: "Europe" },
  { country: "Sri Lanka", region: "Southern Asia", continent: "Asia" },
  { country: "Sudan", region: "Northern Africa", continent: "Africa" },
  { country: "Suriname", region: "South America", continent: "Americas" },
  { country: "Sweden", region: "Northern Europe", continent: "Europe" },
  { country: "Switzerland", region: "Western Europe", continent: "Europe" },
  { country: "Syria", region: "Western Asia", continent: "Asia" },
  { country: "Taiwan", region: "Eastern Asia", continent: "Asia" },
  { country: "Tajikistan", region: "Central Asia", continent: "Asia" },
  { country: "Thailand", region: "South-eastern Asia", continent: "Asia" },
  { country: "The Bahamas", region: "Caribbean", continent: "Americas" },
  { country: "Togo", region: "Western Africa", continent: "Africa" },
  { country: "Tonga", region: "Polynesia", continent: "Oceania" },
  { country: "Trinidad and Tobago", region: "Caribbean", continent: "Americas" },
  { country: "Tunisia", region: "Northern Africa", continent: "Africa" },
  { country: "Turkey", region: "Western Asia", continent: "Asia" },
  { country: "Turkmenistan", region: "Central Asia", continent: "Asia" },
  { country: "Turks and Caicos Islands", region: "Caribbean", continent: "Americas" },
  { country: "Uganda", region: "Eastern Africa", continent: "Africa" },
  { country: "Ukraine", region: "Eastern Europe", continent: "Europe" },
  { country: "United Arab Emirates", region: "Western Asia", continent: "Asia" },
  { country: "United Kingdom", region: "Northern Europe", continent: "Europe" },
  { country: "United Republic of Tanzania", region: "Eastern Africa", continent: "Africa" },
  { country: "United States of America", region: "Northern America", continent: "Americas" },
  { country: "United States Virgin Islands", region: "Caribbean", continent: "Americas" },
  { country: "Uruguay", region: "South America", continent: "Americas" },
  { country: "Uzbekistan", region: "Central Asia", continent: "Asia" },
  { country: "Vanuatu", region: "Melanesia", continent: "Oceania" },
  { country: "Vatican", region: "Southern Europe", continent: "Europe" },
  { country: "Venezuela", region: "South America", continent: "Americas" },
  { country: "Vietnam", region: "South-eastern Asia", continent: "Asia" },
  { country: "Wallis and Futuna", region: "Polynesia", continent: "Oceania" },
  { country: "Western Sahara", region: "Northern Africa", continent: "Africa" },
  { country: "Yemen", region: "Western Asia", continent: "Asia" },
  { country: "Zambia", region: "Eastern Africa", continent: "Africa" },
  { country: "Zimbabwe", region: "Eastern Africa", continent: "Africa" },
  ]